<template>
  <div class="tab-select">
    <div
      v-for="(tab, tabIndex) in tabs"
      :key="tabIndex"
      :class="{
          'item': true,
          'active': tab.key * 1 === currentKey * 1
        }"
      @click="tabChange(tab.key)">
      <div class="name">{{tab.title}}
        <a-tooltip placement="right" v-if="showTip">
          <template slot="title">
            <span>{{tab.tipInfo}}</span>
          </template>
          <img src="@/assets/images/icon-question.png" alt="">
        </a-tooltip>
      </div>
      <slot name="extra" :data="tab"></slot>
    </div>
  </div>
</template>

<script>
import { Tooltip } from 'ant-design-vue'
  export default {
    name: "bTabSelector",
    props: {
      tabs: {
        type: Array,
        default () {
          return []
        }
      },
      showTip: {
        type:Boolean,
        default: false
      },
      defaultKey: {}
    },
    components: {
      [Tooltip.name]: Tooltip
    },
    watch: {
      defaultKey: {
        handler (v) {
          this.currentKey = v
        },
        immediate: true
      }
    },
    data() {
      return {
        currentKey: null
      }
    },
    methods: {
      tabChange (v) {
        this.currentKey = v
        this.$emit('change', v)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tab-select {
    background: $grey-f7;
    .item {
      display: inline-block;
      padding: 10px 30px;
      border-top: 2px solid transparent;
      font-size: 14px;
      color: $content-color;
      &:hover {
        cursor: pointer;
      }
      &.active {
        border-top-color: $primary-main;
        color: $primary-main;
        background: #fff;
      }
      .name {
        width: 100%;
        white-space: nowrap;
        img {
          width: 14px;
          height: 14px;
          margin-left: 4px;
          margin-top: -2px;
        }
      }
    }
  }
</style>
